import { Component, OnInit } from '@angular/core';
import { Book, EditBookModel } from '../../models/inModels/Book';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { NotificationContentType } from '../../models/inModels/MessageModel';
import { Router } from '@angular/router';
import { BookService } from '../../services/book.service';
import { DataTable } from 'primeng/components/datatable/datatable';

@Component({
  selector: 'app-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.css']
})
export class BookComponent implements OnInit {
  	items: Book[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	displayDialog: boolean = false;
	selectedBook: Book;
  constructor(
    	private service: BookService,
		private router: Router,
		private confirmationService: ConfirmationService
  ) {
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
   }

  ngOnInit() {
	
  }
  changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
        console.log(this.items);
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
  }

  delete(event: Book) {
		console.log(event);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${event.Title}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(event.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }
  
	edit(item: Book) {
	   this.router.navigate(['books/edit', item.Id]);
	}

	openModal(item: Book) {
		this.displayDialog = true;
		this.selectedBook = item;

		console.log(this.selectedBook)
	}

	addDiscount() { 
		this.service.addDiscount(this.selectedBook).then((results) => {
			this.selectedBook = results;	
		});
	}

	clearDiscount() {
		this.selectedBook.DiscountPercentage = null;
		this.selectedBook.DiscountEndDateUtc = null; 
		this.selectedBook.DiscountStartDateUtc = null;

		this.service.addDiscount(this.selectedBook).then((results) => {
			this.selectedBook.DiscountPercentage = null;	
		});
	}
  
}



// WEBPACK FOOTER //
// ./src/app/components/book/book.component.ts